import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { PollModalComponent } from "./Compass/PollModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof PollModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <PollModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const usePollModal = () => useModal(CompassModal);
